const faker = require('faker');
const ReactDataGrid = require('react-data-grid');
const React = require('react');

var listcolumns=[{
        key: 'userName',
        name: "用户名",
        width:290,
        resizable: true
      },
      {
        key: 'fileName',
        name: "设置名称",
        width:290,
        resizable: true
      }
    ];
export default class UserSetListDataGrid extends React.Component {
  constructor(props, context) {
    super(props, context);
    //window.ListDataGrid=this;
    var rows=[];
    this.state = { rows:rows, selectedIndexes: []};
  }

  deleteRow=()=>{
   let rows=this.state.rows.slice();
   let selectedIndex=this.state.selectedIndexes[0];
   let row = rows.splice(selectedIndex,1);
   let newSelectedIndex = selectedIndex-1;
   if(newSelectedIndex<0)newSelectedIndex = 0;
   if(newSelectedIndex>=rows.length)
      newSelectedIndex = rows.length-1;

   this.setState({ rows:rows,selectedIndexes:newSelectedIndex});
   if(row && row.length>0)
    row = row[0];
   else
    row = null;
   return {row:row,index:selectedIndex};
  }

  getRowAt = (index) => {
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }
    return this.state.rows[index];;

  };

  getSelectedRow = () =>{
    let selectedIndexes = this.state.selectedIndexes;
    if(!selectedIndexes || selectedIndexes.length<0)
      return null;
    let selectedIndex = selectedIndexes[0];
    let rows=this.state.rows;
    if(selectedIndex>=rows.length || selectedIndex<0)
      return;
    return rows[selectedIndex];
  }

  getSize = () => {
    return this.state.rows.length;
  };

  rowClick = (index,record,proxy) =>{
    this.setState({ selectedIndexes:[index]});
  }

  filterCurrentUser(userId)
  {
   
    var rowsList=[];
    this.backRows = this.state.rows.slice();
    for(var i=0;i<this.state.rows.length;i++)
    {
      var item = this.state.rows[i];
      if(item.userName==userId)
      {
        rowsList.push(item);
      }
    }
    this.setState({rows:rowsList});
  }

  cancelFilterCurrentUser()
  {
    this.setState({rows:this.backRows});
  }
  
  render() {
    return (
     
      <ReactDataGrid
        ref={ node => this.grid = node }
        enableCellSelect={true}
        columns={listcolumns}
        rowGetter={this.getRowAt}
        rowsCount={this.getSize()}
        onGridRowsUpdated={this.handleGridRowsUpdated}
        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
        enableRowSelect={false}
        rowSelection={{
          showCheckbox: false,
          selectBy: {
            indexes: this.state.selectedIndexes
            
          }
        }}
        onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
        rowHeight={30}
        minHeight={250}
        rowScrollTimeout={500} />);
  }
}



// WEBPACK FOOTER //
// ./src/userformset/UserSetListDataGrid.js